const chunkArray = (arr, chunkSize = 2) => {
  const result = [];
  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }
  return result;
};

export default function getTestimonialsBlockData(props) {
  const { testimonials } = props;

  const data = {};
  const cardList = testimonials ? [] : false;

  if (cardList) {
    testimonials.map((entry, index) => {
      const item = {};
      item.id = index;

      item.modifier = index === 1 || index === 4 ? 'TestimonialCard--electricPurple' : false;

      item.quote = entry?.fields?.text ? `“${entry?.fields?.text}”` : false;

      item.author = entry?.fields?.author ? {} : false;
      if (item.author) {
        item.author.name = entry?.fields?.author?.fields?.fullName ? entry.fields.author.fields.fullName : false;
        item.author.jobtitle = entry?.fields?.author?.fields?.jobTitle ? entry.fields.author.fields.jobTitle : false;
        item.author.company = entry?.fields?.author?.fields?.client?.fields?.name
          ? entry.fields.author.fields?.client?.fields?.name
          : false;
        item.author.avatar = entry?.fields?.author?.fields?.avatar ? {} : false;
        if (item.author.avatar) {
          item.author.avatar.image = entry?.fields?.author?.fields?.avatar?.fields?.file?.url
            ? entry.fields.author.fields.avatar.fields.file.url
            : false;
          item.author.avatar.width = entry?.fields?.author?.fields?.avatar?.fields?.file?.details?.image?.width
            ? entry.fields.author.fields.avatar.fields.file.details.image.width
            : false;
          item.author.avatar.height = entry?.fields?.author?.fields?.avatar?.fields?.file?.details?.image?.height
            ? entry.fields.author.fields.avatar.fields.file.details.image.height
            : false;
        }
      }

      if (!item.modifier) {
        item.logo = entry?.fields?.author?.fields?.client?.fields?.logoElectricPurple?.fields?.file?.url;
        item.logoWidth =
          entry?.fields?.author?.fields?.client?.fields?.logoElectricPurple?.fields?.file?.details?.image?.width;
        item.logoHeight =
          entry?.fields?.author?.fields?.client?.fields?.logoElectricPurple?.fields?.file?.details?.image?.height;
      } else {
        item.logo = entry?.fields?.author?.fields?.client?.fields?.logoDeepPurple?.fields?.file?.url;
        item.logoWidth =
          entry?.fields?.author?.fields?.client?.fields?.logoDeepPurple?.fields?.file?.details?.image?.width;
        item.logoHeight =
          entry?.fields?.author?.fields?.client?.fields?.logoDeepPurple?.fields?.file?.details?.image?.height;
      }

      cardList.push(item);
      return true;
    });
  }

  data.list = cardList ? chunkArray(cardList) : false;

  return Object.keys(data).length ? data : false;
}
